<template>
    <el-dialog class="dialog-box" v-if="dialogTableVisible" title="自定义指标" :visible.sync="dialogTableVisible" width="55%" style="min-width: 500px;" top="5vh">
        <el-row class="center-box" :gutter="24">
            <el-col :md="24" :lg="24"> <!-- :md="17" :lg="17" -->
                <el-card class="left-card" shadow="never">
                    <!-- <div slot="header" class="clearfix">
                        <span>可添加指标</span>
                        <el-input size="mini" v-model="search" placeholder="请输入列名称搜索" clearable style="float:right; width:160px"></el-input>
                    </div> -->
                    <el-row class="center-box" :gutter="24"  v-loading="loading">
                        <el-col :md="3" :lg="3" class="hidden-sm-and-down"> <!-- :md="4" :lg="5" -->
                            <div class="lef-list">
                                <el-scrollbar wrap-class="scrollbar-wrapper">
                                    <div class="item" v-for="(item,index) in sourceData" :key="item.property" :class="{active:index==current}" @click="tabclick(index)">
                                        {{item.label}}
                                    </div>
                                </el-scrollbar>
                            </div>
                        </el-col>

                        <el-col :sm="24" :md="21" :lg="21"> <!-- :md="20" :lg="19" -->
                            <div class="right-list" v-if="sourceData.length > 0">
                                <el-scrollbar wrap-class="scrollbar-wrapper">
                                    <div class="item" v-for="(item,index) in sourceData" :key="item.property" v-if="item.children && item.children.length > 0">
                                        <div class="title">
                                            <el-checkbox v-model="item.checked" @change="handleCheckAll($event, item)"></el-checkbox>
                                            <span style="margin-left:3px" :id="index">{{item.label}}</span>
                                        </div>
                                        <div class="box">
                                            <div class="box-item" v-for="sonItem in item.children" :key="sonItem.property">
                                                <el-checkbox :disabled="sonItem.disabled" v-model="sonItem.checked" @change="handleChecked($event, item)"></el-checkbox>
                                                <span style="margin-left:3px">{{sonItem.label}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </el-scrollbar>
                            </div>
                            <div class="tips" v-else>
                                暂无相关数据
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>

            <!-- <el-col :md="7" :lg="7" class="hidden-sm-and-down">
                <el-card class="right-card">
                    <div slot="header" class="clearfix">
                        <span>已选 {{num}} 列</span>
                        <el-button style="float: right; padding: 4px 0" type="text" @click="handleEmpty">清空</el-button>
                    </div>
                    <div class="card-box">
                        <el-scrollbar wrap-class="scrollbar-wrapper">
                            <template v-for="item in sourceData">
                                <draggable :list="item.children" class="dragArea" :key="item.property">
                                    <div class="item" v-for="sonItem in item.children" :key="sonItem.property" :class="sonItem.disabled ? 'disabled' : ''" v-if="sonItem.checked">
                                        <i class="el-icon-s-operation lie-icon"></i>
                                        <span>{{sonItem.label}}</span>
                                        <i class="el-icon-circle-close delete-icon" @click="handleDelete(sonItem,item)"></i>
                                    </div>
                                </draggable>
                            </template>
                        </el-scrollbar>       
                    </div>
                </el-card>
            </el-col> -->
        </el-row>

        <div class="dialog-butn-box" style="margin: 20px 10px 10px">
            <el-button size="small" @click="dialogTableVisible = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="dialogLoading" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'
import draggable from 'vuedraggable'
export default {
    components:{draggable},
    props: {
        // 原始数据
        sourceData:{
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            dialogTableVisible: false,
            loading: false,
            search:'',
            num: 0, // 已选条数

            dialogLoading: false,

            current: 0,
            // selectedData:[], // 已选
        }
    },

    computed: {
        // 待选过滤
        // resultData() { 
        //     const search = this.search.toLowerCase().replace(/\s+/g,"");
        //     const list = JSON.parse(JSON.stringify(this.sourceData))
        //     if(search) {
        //         return list.map(v => {
        //             if(v.children && v.children.length > 0) {
        //                 v.children = v.children.filter(item => {
                            
        //                     return String(item['label']).toLowerCase().indexOf(search) > -1
        //                 })
        //             }
        //             return v
        //         })
        //     }

        //     return this.sourceData
        // }
    },

    methods: {
        // init
        init() {
            this.dialogTableVisible = true
            this.search = ''

            this.loading = true
            this.dialogLoading = false
        },

        // 全选
        handleCheckAll(e, obj) {
            // console.log(e,obj)
            if(e) {
                obj.children.forEach(item => {
                    item.checked = true
                });
            } else {
                obj.children.forEach(item => {
                    if(item.disabled == false) {
                        item.checked = false
                    }
                });
            }
        },

        // 单选
        handleChecked(e, obj, item) {
            let nums = 0;
            obj.children.forEach(item => {
                if(item.checked) {
                    nums ++;
                }
            })

            if (nums == obj.children.length) {
                obj.checked = true;
            } else {
                obj.checked = false;
            }
        },

        // 保存
        handleSave() {
            this.dialogLoading = true
            this.$emit('handleSave', this.sourceData)
        },

        // 锚点
        tabclick(index) {
            this.current=index;
            let anchorElement = document.getElementById(index);
            if(anchorElement) { 
                anchorElement.scrollIntoView(); 
            }  
        },

        // 清空
        handleEmpty() {
            this.sourceData.forEach(arr => {
                if(arr.disabled == false) {
                    arr.checked = false
                }

                arr.children.forEach(item => {
                    if(item.disabled == false) {
                        item.checked = false
                    }
                })
            })
        },

        // 删除
        handleDelete(item, obj) {
            if(item.disabled == false) {
                item.checked = false
                this.handleChecked(false,obj)
            }
        }
    }

}
</script>

<style lang="scss" scoped>

    .dialog-box{
        ::v-deep .el-dialog__body{
            padding: 0px 10px 10px;
        }
        ::v-deep .el-card__header{
            padding: 5px 12px;
            line-height: 28px; 
            background: #f7faff;
        }
        ::v-deep .el-card__body{
            padding: 0px 12px;
        }
        .lef-list{
            height: 550px;
            padding: 10px 10px 0 0;
            border-right:1px solid #e1e3e7;
            .item {
                cursor: pointer;
                height: 30px;
                line-height: 30px;
                background: #fff;
                color: #132344;
                position: relative;
            }
        }
        .right-list {
            padding: 10px 0 0 10px;
            height: 550px;
            .item {
                margin-bottom: 20px;
                .title {
                    height: 30px;
                    line-height: 30px;
                    padding-bottom: 5px;
                    border-bottom: 1px solid #e1e3e7;
                    color: #132344;
                    font-size: 14px;
                    font-weight: bolder;
                    margin-bottom: 4px;
                }
                .box {
                   display: flex;
                   flex-wrap: wrap; 
                }
            }
            .box-item{
                margin: 10px 10px 5px;
                min-width: 75px;
            }

        }

        ::v-deep .scrollbar-wrapper {
            overflow-x: hidden !important;
        }

        .el-scrollbar__bar.is-vertical {
            right: 0px;
        }

        .el-scrollbar {
            height: 100%;
        }

        .tips{
            height: 300px;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: #b5b5b5;
        }

        .active{
            background: #f0f6ff;
            color: #1d71e8 !important;
        }

        .right-card{
            .card-box{
                margin: 10px 0;
                height: 530px;
            }
            .item{
                height: 32px;
                line-height: 32px;
                margin-bottom: 8px;
                padding: 0 10px;
                background: #eaf3ff;
                border: 1px solid #e3e5e7;
                border-radius: 3px;
                font-size: 12px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: #4b5276;
                display: flex;  
                flex-flow: row nowrap;
                justify-content: flex-start;
                align-items: center;

                span{
                    flex: 1;
                    margin: 0 5px;
                    cursor: move;
                }
                i{
                    font-size: 16px;
                    color: #aeb3c4;
                }
                .lie-icon{
                    cursor: move;
                }
                .delete-icon{
                    color:#9ebadf;
                    cursor: pointer;
                }
            }
            .disabled{
                color: #c0c4cc;
                cursor: not-allowed;
                background-image: none;
                background-color: #fff;
                border-color: #ebeef5;
                .delete-icon{
                    cursor: not-allowed !important;
                }
               
            }
        }
    }

    
</style>